export interface UploadResult {
  messageId: string;
  url: string;
}

export abstract class ImgUploadPort {
  abstract uploadFile(file: File): Promise<UploadResult>;
  abstract uploadFiles(files: File[]): Promise<UploadResult[]>;
}
